<template>
  <div>
    <div class="record-result-name">查詢結果：{{ name | securityHidden('Ｏ', 1, 1) }}</div>
    <listTable :bookingList="bookingList" @input="recordClick"> </listTable>
    <div class="record-restart-query">
      <div class="temple-button-text" @click="clickRestartQuery">
        重新查詢
      </div>
    </div>
  </div>
</template>

<script>
import store from 'Store/store';
import listTable from 'Components/table/listTable.vue';

export default {
  name: 'ServiceRecordStep2',
  components: {
    listTable,
  },
  props: {
    name: {
      type: String,
    },
  },
  mounted() {
    window.scrollTo({ behavior: 'auto', top: 0 });
  },
  methods: {
    recordClick(bookingRecord) {
      this.$emit('queryRecordDetail', bookingRecord);
    },
    clickRestartQuery() {
      this.$emit('restartQuery');
    },
  },
  computed: {
    bookingList() {
      return store.state.main.bookingList;
    },
  },
};
</script>

<style scoped>
.record-restart-query {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.record-result-name {
  font-size: 16px;
  font-weight: bold;
  margin: 30px 0 20px 0;
}
</style>
